import React from 'react'
import { motion } from 'framer-motion'

// SimpleTwoStepProgress
// props:
// - currentStep: 1 or 2
// - onStepChange: optional function(stepNumber)

export default function SimpleTwoStepProgress({ currentStep = 1 }) {
  const navy = '#1e3a8a'
  const percent = currentStep === 1 ? 50 : 100

  return (
    <div className="w-[100px] max-w-xl mx-auto" dir="rtl">

      <div className="w-full bg-[rgba(2,6,23,0.06)] rounded-full h-2 overflow-hidden">
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${percent}%` }}
          transition={{ duration: 0.35, ease: 'easeOut' }}
          style={{ background: navy, height: '100%' }}
        />
      </div>

 
      <div className="flex justify-center mt-3 text-sm text-gray-700">
 
          <span className={`font-medium text-[12px] text-gray-800`}>{`مرحله ${currentStep} از 2`}</span>
      </div>
    </div>
  )
}
